import React, { memo, RefObject, useMemo, VFC } from 'react'
import styled from 'styled-components'

type RTEContentProps = Omit<React.DetailedHTMLProps<React.BaseHTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'dangerouslySetInnerHTML' | 'ref'> & {
  html: string
  ref?: RefObject<HTMLDivElement>
}

const StyledRTEDiv = styled.div(({ theme }) => ({
  a: {
    color: theme.colors.primary,
    textDecoration: 'underline',
  },
  'div[data-type="hr"]': {
    'border-top': '2px solid #bbb !important',
  },
  ul: {
    margin: '0 0 1.2em 1.333em',

    li: {
      marginBottom: '.333em',
      paddingLeft: '.333em',

      '&::before': {
        color: theme.colors.primary,
        content: "'•'",
        display: 'inline-block',
        marginLeft: '-1.25rem',
        position: 'absolute',
        transform: 'scale(2) translate(.133em, .03em)',
        width: '1.25rem',
      },
    },
  },
}))

export const RTEContent: VFC<RTEContentProps> = memo(({ html, ...props }) => {
  const processedRTEContent = useMemo(() => (html || '').trim().replace(/\n/g, '<br/>'), [html])

  return (
    <StyledRTEDiv dangerouslySetInnerHTML={{ __html: processedRTEContent }} {...props} />
  )
})
